/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const findIngestionSettingsResponseDtoTraceabilityMethodEnum = {
  DEFAULT: "DEFAULT",
  PO: "PO",
  MULTISOURCING: "MULTISOURCING",
} as const

export type FindIngestionSettingsResponseDtoTraceabilityMethodEnumKey =
  (typeof findIngestionSettingsResponseDtoTraceabilityMethodEnum)[keyof typeof findIngestionSettingsResponseDtoTraceabilityMethodEnum]

export type FindIngestionSettingsResponseDto = {
  /**
   * @type string
   */
  traceabilityMethod: FindIngestionSettingsResponseDtoTraceabilityMethodEnumKey
  /**
   * @type array
   */
  defaultStandards: string[]
}
